import type { ChildDom } from "vanjs-core";

export interface ViewComponent {
	ChildDom: ChildDom;
}

export function scrollIntoView(c: ChildDom): void {
	if (!(c instanceof HTMLElement)) throw "ChildDom is not an html element";
	if (!c.isConnected) throw "ChildDom is not connected";
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			c.scrollIntoView({
				behavior: "smooth",
				block: "center",
				inline: "center",
			});
		});
	});
}

export function scrollToTop(): void {
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
		});
	});
}
